import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { NavController } from '@ionic/angular/standalone';
import { HomeService } from 'src/app/services/home.service';
import { storageKeys } from 'src/app/app.constants';
import { NavigationExtras, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { IonCol, IonContent, IonGrid, IonItem, IonLabel, IonRow } from '@ionic/angular/standalone';
import { BackButtonComponent } from 'src/app/components/back-button/back-button.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-certificate-count-details',
  templateUrl: './certificate-count-details.component.html',
  styleUrls: ['./certificate-count-details.component.scss'],
  imports: [
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonLabel,
    BackButtonComponent,
    CommonModule, 
    FormsModule, 
    ReactiveFormsModule,
    TranslateModule
  ]
})
export class CertificateCountDetailsComponent implements OnInit {
  certArr: any;
  certificateColSize : number = 12;
  imageKey: any = 'certificateSearchImage';
  flow: string = null
  constructor(
    public commonServ: CommonService,
    public navCtrl: NavController,
    public homeService: HomeService,
    public router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    const extras = this.router.getCurrentNavigation().extras
    if (extras?.state) {
      this.flow = extras.state.flow
    }
    this.certArr = this.commonServ.certificatesArr;
    if(environment.uiVersion == 2 || environment.uiVersion == 3){
      this.certificateColSize = 6;
      this.imageKey = 'certificateImage';
    }
    //console.log('CertificateArr ==>',this.certArr)
  }
  // Go To Certificate Detail
  goToCertificateDatail(certificate, serviceType) {
    //console.log("Selected Certificate===>",certificate);
    if (serviceType == storageKeys.dine) {
      this.homeService.serviceType = storageKeys.appDine;
    } else if (serviceType == storageKeys.other) {
      this.homeService.serviceType = storageKeys.other;
    } else if (serviceType == storageKeys.pool) {
      this.homeService.serviceType = storageKeys.pool;
    } else if (serviceType == storageKeys.appSpa) {
      this.homeService.serviceType == serviceType.appSpa
    } else if (serviceType == storageKeys.stay) {
      this.homeService.serviceType = storageKeys.appStay;
    } else {
      this.homeService.serviceType = storageKeys.other;
    }
    this.homeService.selectedCertificate = { aemData: certificate, sfdcData: certificate, alldata: this.certArr };
    this.homeService.selectedCertificate['flowType'] = 'certificate';
    this.homeService.benefitCode = {
      benefitType: storageKeys.certificate,
      value: certificate.certificateID
    }
    // //console.log('ServiceType==>', serviceType)
    let apiReq = {
      "id": certificate.certificateID,
      "type": "Certificate",
    }
   this.commonServ.presentLoader(this.translate.instant('loader.fetchData'));
    this.homeService.getDetailFunc(apiReq).then(res => {
      if (res) {
        this.homeService.completeDataOfSelectedBenefit = res;
        const extras: NavigationExtras = {
          state: {
            flow: this.flow
          }
        }
        this.navCtrl.navigateForward(['/certificate-detail'], extras);
      }
      this.commonServ.dismissLoader();
    }, err => {
      this.homeService.handleAPIError(err);
    })
  }


}
